import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    window.addEventListener('resize', this.#handleResize);
  }

  disconnect() {
    window.removeEventListener('resize', this.#handleResize);
  }

  #handleResize = () => {
    const footer = document.querySelector('.sc-Actions');
    const content = document.querySelector('.mobileWeb .sc-SiteLayout-main .sc-SectionLayout');

    if (footer && content) {
      const inputs = document.querySelectorAll('input, textarea');
      if (inputs.length > 0) {
        window.scrollBy(0, 100);
      }
    }
  };
}
